module.exports = __webpack_public_path__ + "img/tastings.a4793b9d.jpg";